import React  from 'react';
import NumberComponentProto from './number-proto.jsx';


export default function renderNumberInEdit(id, props) {
    return <NumberComponentProto renderMode="edit" id={id} {...props} />;
}